<template>
<v-card @mouseover="hover=true" @mouseleave="hover=false" height="100%">
    <v-card-title primary-title>
        <div class="hotel-card-title pa-2">
            {{ $t('hotel.card.facilities.title') }}
        </div>
        <v-spacer></v-spacer>
        <div class="procent" @click="status_dialog = true">
            <span :class="color + '--text'">
                {{ procent_status }}%
            </span>
            <v-icon size="19" :color="color">info</v-icon>
        </div>
        <v-tooltip bottom>
            <template v-slot:activator="{ on }">
                <div v-on="on" class="procent" @click="status_dialog = true">
                    <span :class="color + '--text'">
                        {{ procent_status }}%
                    </span>
                    <v-icon size="19" :color="color">info</v-icon>
                </div>
            </template>
            <div class="">
                <div class=" important white--text">
                    Rata completare <span class="text-lowercase"> {{ $t('hotel.card.facilities.title') }} </span>
                </div>
                <div class="">
                    Un numar mai mare de facilitati va pot aduce mai multe rezervari
                </div>
            </div>
        </v-tooltip>
        <v-icon class="pa-1 icon-edit" color="#5A8DEE" v-show="hover" @click="emitOpenDialog()">edit</v-icon>
    </v-card-title>
    <v-card-text>
        <div class="px-1 card-custom" :style="'overflow-y:auto;max-height:'+ max_height +'px'">
            <div class="" v-for="activity in activities_ids" :key="'activity_'+ activity">
                {{ $t('hotel-activities.'+ config.activities.find(function(item) { return item.id == activity }).slug) }}
            </div>
            <div class="" v-for="facility in facilities_ids" :key="'facility_'+ facility">
                {{ $t('hotel-facilities.'+ config.facilities.find(function(item) { return item.id == facility }).slug) }}
            </div>
        </div>
    </v-card-text>

    <!--info dialog-->
    <v-dialog v-model="status_dialog" max-width="720">
        <v-card>
            <v-card-title class="hotel-card-title" primary-title>
                Info
            </v-card-title>
            <v-card-text class="info-text">
                <div class="">
                    Un numar mai mare de facilitati va pot aduce mai multe rezervari
                </div>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" text @click="status_dialog=false">
                    {{ $t('button.exit') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!--./info dialog -->
</v-card>
</template>

<script>
import {
    mapActions
} from 'vuex';

export default {
    props: {
        item: Object,
        config: Object,
        active: Object,
    },
    name: `hotel-facilities`,

    data() {
        return {
            status_dialog: false,
            hover: false,
            color: 'grey',
            hover: false,
            max_height: 200,
            activities_ids: [],
            facilities_ids: [],
            selected_activities: [],
            selected_categories: [],
            selected_facilities: [],
            facilities_categories: [],
            search: null,
            select: null,
        };
    },

    computed: {
        procent_status() {
            let procent = 0;
            let length_value = this.facilities_ids.length + this.activities_ids.length;

            if(length_value > 0 && length_value < 6) {
                procent += 50;
            }

            if(length_value > 5 && length_value < 11) {
                procent += 80;
            }
            if(length_value > 11 && length_value < 15) {
                procent += 90;
            }
            if(length_value > 15) {
                procent += 100;
            }

            this.setColor(procent);
            return procent;
        }
    },

    mounted() {
        // prepare models  for activities and facilities selection
        let f_ids = [];
        if(Array.isArray(this.item.static.facilities)) {
            this.item.static.facilities.forEach(function (item) {
                if(item !== null) {
                    this.facilities_ids.push(Number(item.id))
                }
            }.bind(this))
        } else {
            f_ids = Object.keys(this.item.static.facilities);
            f_ids.forEach(function (item) {
                if(this.item.static.facilities[item] !== null && this.item.static.facilities[item].id == item) {
                    this.facilities_ids.push(Number(item));
                }
            }.bind(this))
        }

        let a_ids = [];
        if(Array.isArray(this.item.static.activities)) {
            this.item.static.activities.forEach(function (item) {
                if(item !== null) {
                    this.activities_ids.push(Number(item.id))
                }
            }.bind(this))
        } else {
            a_ids = Object.keys(this.item.static.activities);
            a_ids.forEach(function (item) {
                if(this.item.static.activities[item] !== null && this.item.static.activities[item].id == item) {
                    this.activities_ids.push(Number(item))
                }
            }.bind(this))
        }

        this.$nextTick(() => {
            if(document.getElementById('policy-card')) {
                this.max_height = document.getElementById('policy-card')
                    .offsetHeight;
            }
        })
    },

    watch: {
        item: {
            handler: function (value) {
                this.facilities_ids = [];
                let f_ids = [];
                if(Array.isArray(this.item.static.facilities)) {
                    this.item.static.facilities.forEach(function (item) {
                        if(item !== null) {
                            this.facilities_ids.push(Number(item.id))
                        }
                    }.bind(this))
                } else {
                    f_ids = Object.keys(this.item.static.facilities);
                    f_ids.forEach(function (item) {
                        if(this.item.static.facilities[item] !== null && this.item.static.facilities[item].id == item) {
                            this.facilities_ids.push(Number(item))
                        }
                    }.bind(this))
                }

                let a_ids = [];
                this.activities_ids = [];
                if(Array.isArray(this.item.static.activities)) {
                    this.item.static.activities.forEach(function (item) {
                        if(item !== null) {
                            this.activities_ids.push(Number(item.id))
                        }
                    }.bind(this))
                } else {
                    a_ids = Object.keys(this.item.static.activities);
                    a_ids.forEach(function (item) {
                        if(this.item.static.activities[item] !== null && this.item.static.activities[item].id == item) {
                            this.activities_ids.push(Number(item))
                        }
                    }.bind(this))
                }
            },
            deep: true
        },

    },

    methods: {

        ...mapActions('alert', ['success', 'error']),

        setColor(procent) {
            if(procent < 51) {
                this.color = 'red'
            }
            if(50 < procent && procent < 81) {
                this.color = 'orange'
            }
            if(procent > 80) {
                this.color = 'green'
            }
        },

        emitOpenDialog() {
            this.$emit('openDialog');
        }
    },

};
</script>
<style lang="stylus">
.menu-fixed
    position: sticky
    top: 90px
    ul
        height: 24px
        line-height: 24px
        list-style-type: none

.customActive
    padding-left: 10px
    border-left: 2px solid blue
.card-custom
    /* width */
    &::-webkit-scrollbar
        width: 10px
    /* Track */
    &::-webkit-scrollbar-track
        box-shadow: inset 0 0 5px grey
        border-radius: 10px
    /* Handle */
    &::-webkit-scrollbar-thumb
        background: #5A8DEE
        border-radius: 10px
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover
        background: #5A8DEE
</style>
